import React, { useState } from 'react';
import { Modal, Typography, Button, List, Spin } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { themeColors } from 'theme';
import { getSavedSolicitations, removeSavedSolicitation } from 'services/solicitation-service';

const { Text } = Typography;

export const SolicitationSavedTemplate = ({ open, onClose, onConfirm }) => {
    const [orders, setOrders] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [templateToDelete, setTemplateToDelete] = useState(null);

    React.useEffect(() => {
        if(open) {
            load();
        }
    }, [open])

    const load = async () => {
        setLoading(true);
        try {
            const templates = await getSavedSolicitations();
            setOrders(templates);
            if (templates.length > 0) {
                setSelectedId(templates[0].id);
            } else {
                setSelectedId(null);
            }
        } catch (ex) {
            console.log(ex);
        }
        setLoading(false);
    }

    const handleSelect = (id) => {
        setSelectedId(id);
    };

    const handleRemoveClick = (item) => {
        setTemplateToDelete(item);
        setIsDeleteModalOpen(true);
    };

    const confirmRemoval = async () => {
        setLoading(true);
        try {
            await removeSavedSolicitation(templateToDelete.id);
            setIsDeleteModalOpen(false);
            await load();
        } catch (ex) {
            console.log(ex);
        }
        setLoading(false);
    };

    const handleConfirm = () => {
        const selectedOrder = orders.find(order => order.id === selectedId);
        onConfirm(selectedOrder);
    };

    return (
        <>
            <Modal
                open={open}
                onCancel={onClose}
                title="Pedidos salvos"
                footer={null}
                closeIcon={<CloseOutlined />}
                centered
                width={380}
            >
                <Spin spinning={loading}>
                    <div>
                        <List
                            itemLayout="horizontal"
                            dataSource={orders}
                            pagination={{
                                position: 'bottom',
                                align: 'center',
                                pageSize: 5,
                            }}
                            renderItem={item => {
                                const isSelected = item.id === selectedId;
                                return (
                                    <List.Item
                                        onClick={() => handleSelect(item.id)}
                                        style={{
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #f0f0f0',
                                            padding: '12px 16px',
                                            backgroundColor: isSelected ? themeColors.mediumColor : 'transparent',
                                            color: isSelected ? '#fff' : 'inherit',
                                            transition: 'background-color 0.3s',
                                            borderRadius: 10,
                                            height: 65,
                                            marginBottom: 10
                                        }}
                                    >
                                        <List.Item.Meta
                                            title={<Text style={{color: isSelected ? '#fff' : ''}}>{item.name}</Text>}
                                            description={<Text style={{color: isSelected ? '#fff' : ''}}>{item.description}</Text>}
                                        />
                                        <CloseOutlined
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleRemoveClick(item);
                                            }}
                                            style={{ color: isSelected ? '#fff' : 'rgba(0,0,0,0.45)', fontSize: '16px' }}
                                        />
                                    </List.Item>
                                );
                            }}
                        />
                    </div>
                    <div style={{ textAlign: 'right'}}>
                        <Button
                            type="primary"
                            onClick={handleConfirm}
                            disabled={!selectedId}
                            block
                            style={{
                                marginTop: 20,
                                backgroundColor: themeColors.mediumColor,
                                borderColor: themeColors.mediumColor,
                                height: 40,
                                width: 100
                            }}
                        >
                            Confirmar
                        </Button>
                    </div>
                </Spin>
            </Modal>
            <Modal
                title=" "
                open={isDeleteModalOpen}
                onCancel={() => setIsDeleteModalOpen(false)}
                footer={null}
                centered
                width={380}
                closeIcon={<CloseOutlined />}
            >
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                        Deseja excluir "{templateToDelete?.name}"?
                    </p>
                    <div style={{ marginTop: '30px' }}>
                        <Button
                            style={{ marginRight: '10px', backgroundColor: themeColors.mediumColor, color: '#fff' }}
                            onClick={() => setIsDeleteModalOpen(false)}
                        >
                            Cancelar
                        </Button>
                        <Button
                            type="primary"
                            danger
                            onClick={confirmRemoval}
                            style={{ backgroundColor: themeColors.primaryColor, borderColor: themeColors.primaryColor }}
                        >
                            Excluir
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
};